import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useStateContext } from '../../contexts/ContextProvider';
//import NotAuthorized from '../../components/NotAuthorized';
import Pagination from '../../components/Pagination';
import { deletePaymentRequest, getMyPaymentsRequest } from '../../store/payments/actions';
import { settingsData } from '../../data/dummy';
import { useTranslation } from 'react-i18next';

const MyPayments = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { payments, pageCount, currentPage, totalCount } = useSelector(state => state.payments);
  const { currentColor } = useStateContext();
  const [confirmModal, setConfirmModal] = useState(false);
  const [selectedPaymentId, setSelectedPaymentId] = useState(null);
  const { user } = useSelector(state => state.auth);
  const [payload, setPayload] = useState({
    search: '',
    date: '',
    page: 0,
  });

  useEffect(() => {
      dispatch(getMyPaymentsRequest(payload));
  }, [payload, dispatch]);

  const onPageChange = (page) => {
    if (page.selected !== (currentPage + 1)) {
      setPayload({ ...payload, page: page.selected });
    }
  }

  const handleDeletePayment = () => {
    dispatch(deletePaymentRequest(selectedPaymentId));
    setConfirmModal(false);
  }


  /* if (user?.role > 4) {
    return <NotAuthorized />
  } */

  return (
    <div className="m-2 md:m-6 p-2 md:p-6">
      <div className="flex justify-between items-center mt-20 sm:mt-0">
        <p className="text-3xl font-extrabold tracking-tight dark:text-white text-slate-600	" 
            style={{ color: currentColor }}>
              {totalCount && <b>{totalCount}</b>} {t("payments_value")}
        </p>
        <div className="flex items-center">
        </div>
      </div>
      <div className='flex justify-end items-center py-4'>
        <input type="text" className="w-1/3 sm:w-1/4 px-4 py-3 bg-gray-100 focus:outline-none" placeholder={t("search_by_customer")} value={payload.search} onChange={(e) => setPayload({ ...payload, search: e.target.value })} />
        <input type="date" className={`w-1/3 sm:w-1/4 px-4 py-3 bg-gray-100 focus:outline-none ${i18n.language === "ar" ? 'mr-4' : 'ml-4'}`} placeholder={t("search_by_date")} value={payload.date} onChange={(e) => setPayload({ ...payload, date: e.target.value })} />
      </div>
      <div className='table_container'>
        <table className='w-full rounded-md table-auto'>
          <thead className='border border-gray-100 bg-gray-100'>
            <tr>
              <th className={`hidden sm:table-cell px-2 sm:px-4 py-3 text-sm ${i18n.language === 'ar' ? 'text-right' : 'text-left' }`}>{t("o_ref")}</th>
              <th className='px-2 sm:px-4 py-3 text-sm text-center'>{t("date")}</th>
              <th className='px-2 sm:px-4 py-3 text-sm text-right'>{t("amount")}</th>
            </tr>
          </thead>
          <tbody>
            {payments?.map(payment => (
              <tr key={payment._id}>
                <td className={`hidden sm:table-cell text-sm border border-gray-100 dark:border-gray-500 px-2 sm:px-4 py-2 dark:text-slate-100 ${i18n.language === 'ar' ? 'text-right' : 'text-left' }`}>{payment.order?.ref}</td>
                <td className='text-xs sm:text-sm border border-gray-100 dark:border-gray-500 px-2 sm:px-4 py-2 dark:text-slate-100 text-center'>{payment.date}</td>
                <td className='text-xs sm:text-sm border border-gray-100 dark:border-gray-500 px-2 sm:px-4 py-2 dark:text-slate-100 text-right relative'><b>{parseFloat(payment.amount)?.toFixed(2)}</b> {t(settingsData.organization_currency)} 
                {payment.mode === "refund" 
                  ? <img className="absolute top-2 left-2 w-4 h-4 shadow-lg" src="/images/minus.png" alt="Minus" /> 
                  : <img className="absolute top-2 left-2 w-4 h-4 shadow-lg" src="/images/plus.png" alt="Plus" />}
                </td>
               </tr>
            ))}
          </tbody>
        </table>
      </div>
      <Pagination
         pageCount={pageCount}
         onPageChange={(page) => onPageChange(page)}
        />
      <div className={`noprint flex justify-center items-center w-screen h-screen fixed top-0 left-0 transition-all bg-black bg-opacity-25 ${confirmModal ? 'opacity-100 pointer-events-auto	' : 'opacity-0 pointer-events-none'}`}>
        <div className="w-400 p-8 bg-white shadow-lg rounded-md">
          <p className='text-lg text-bold mb-6'>Confirm Delete?</p>
          <div className="flex justify-end">
            <button className="mx-1 bg-transparent border border-blue-500 hover:border-blue-700 text-blue-500 hover:text-blue-700 font-bold py-2 px-6 rounded-md" onClick={() => setConfirmModal(false)}>
              {t("cancel")}
            </button>
            <button className="mx-1 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-md" onClick={() => handleDeletePayment()}>
              {t("delete")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default MyPayments;
